module.exports = __webpack_public_path__ + "static/media/beech-not-selected.df216b38.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/tags/beech-not-selected.svg
// module id = 68
// module chunks = 0